/*
 state: [id1, id2, ..]
 */

export function clear() {
  return [];
}

export function excludeVideoIdsFromPrams(state, { payload }) {
  const { videoIds } = payload.params;
  return _.without(state, ...videoIds);
}

export function replaceIds(state, oldIds, newIds) {
  oldIds = _.castArray(oldIds);
  newIds = _.castArray(newIds);

  return _.map(state, function (id) {
    const indexInOldIds = _.indexOf(oldIds, id);
    if (indexInOldIds === -1) {
      // video hasn't been just added
      return id;
    }

    return newIds[indexInOldIds];
  });
}



// WEBPACK FOOTER //
// ./src/shared/redux/helpers/ids.js